import React from 'react';
import util from '../util/util';
import api from '../api/api';
import $ from 'jquery';

export default class MobileMenu extends React.Component {
    constructor(props){
        super(props)
        
        this.state = {
			IsLoggedIn: user.isLoggedIn,
			fullName: user.firstName + ' ' + user.lastName,
        }
        this.openMenu = this.openMenu.bind(this);
    }
	
	openMenu() {
		if($('#mobileMenu').hasClass('menuOpen')){
			$('#mobileMenu').removeClass('menuOpen');
		}else{
			$('#mobileMenu').addClass('menuOpen');
		}
	}
	
	render() {
		let mobileProfileInfo = user.isLoggedIn ? <li className="mobileProfileInfo">{this.state.fullName}<br /></li> : null;
		let navMyAccount = user.isLoggedIn ? <li className="mobileLinks"><a href="/myAccount/" className="navMyAccount"><small>My Account</small></a></li> : null;
		let navMyCart = user.isLoggedIn ? <li className="mobileLinks"><a href="/shoppingCart.cfm" className="navMyAccount"><small>Shopping Cart</small></a></li> : null;
		
		let searchLink = <li className="mobileLinks getQuote"><a href="/searchResults.cfm" className="navMyAccount"><small>Browse Products</small></a></li>;
		let signup = !user.isLoggedIn ? <li style={{float:'right'}}><a href="/signup.cfm" className="navMyAccount">Sign Up</a></li> : null;
		let loginLink = !user.isLoggedIn ? <li style={{float:'right'}}><a href="/login.cfm" className="navMyAccount">Login</a></li> : null;
		
		let logoutLink = user.isLoggedIn ? <li className="mobileLinks"><a href="/logout.cfm" className="navMyAccount"><small>Logout</small></a></li> : null;
		return (
			<div id="mobileMenu">
				<ul>
					{mobileProfileInfo}
					{navMyAccount}
					{navMyCart}
					{searchLink}
					<li className="mobileLinks">
						<a href="/contactus.cfm" className="navMyAccount"><small>Contact Us</small></a>
					</li>
					<li className="mobileLinks">
						<a href="/howItWorks.cfm" className="navMyAccount"><small>How it Works</small></a>
					</li>
					{logoutLink}
					{signup}
					{loginLink}
				</ul>
			</div>
		)
	}
}


/** WEBPACK FOOTER **
 ** ./app/reusable/mobileMenu.js
 **/